export const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 700,
        boxShadow: 'none',
        letterSpacing: '0.01em',
        transition: 'all 0.2s ease',
      },
      containedPrimary: {
        backgroundColor: '#B77B1A',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#9E6510',
        },
      },
      outlinedPrimary: {
        borderColor: '#E4D7B8',
        color: '#1F2522',
        '&:hover': {
          borderColor: '#B77B1A',
          backgroundColor: '#FFF8EC',
        },
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 12px 28px rgba(20, 25, 23, 0.05)',
        borderBottom: '1px solid #EAE4D9',
        backgroundColor: '#ffffff',
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        maxWidth: '1440px',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: '0 12px 30px rgba(17, 23, 20, 0.04)',
      },
    },
  },
};
